import { ActionType, Action } from './actionTypes';
import { CalculatorProduct, CalculatorSummary, ReferenceDataItem } from './state';

export const updateAge = (age?: number): Action => ({
    type: ActionType.UpdateAge,
    age,
});

export const updateStudentAgeDob = (age?: number, dateOfBirth?: string): Action => ({
    type: ActionType.UpdateStudentAgeDob,
    age,
    dateOfBirth,
});

export const updateAgent = (agentId?: string): Action => ({
    type: ActionType.UpdateAgent,
    agentId,
});

export const updateAgentType = (agentType: 'Walk In' | 'E-Sale' | 'Agent'): Action => ({
    type: ActionType.UpdateAgentType,
    agentType,
});

export const updateCountryOfResidence = (countryId?: string): Action => ({
    type: ActionType.UpdateCountryOfResidence,
    countryId,
});

export const updateDestinationCountry = (countryId?: string): Action => ({
    type: ActionType.UpdateDestinationCountry,
    countryId,
});

export const updateBookingCreationDate = (date?: string): Action => ({
    type: ActionType.UpdateBookingCreationDate,
    date,
});

export const updateCurrency = (currencyId?: string): Action => ({
    type: ActionType.UpdateCurrency,
    currencyId,
});

export const updateDateFrom = (date?: string): Action => ({
    type: ActionType.UpdateDateFrom,
    date,
});

export const updateCentre = (centreId?: string): Action => ({
    type: ActionType.UpdateCentre,
    centreId,
});

export const updateWeeks = (weeks?: number): Action => ({
    type: ActionType.UpdateWeeks,
    weeks,
});

export const updateSchool = (schoolId?: string): Action => ({
    type: ActionType.UpdateSchool,
    schoolId,
});

export const updateDateTo = (date?: string): Action => ({
    type: ActionType.UpdateDateTo,
    date,
});

export const updateBookingSystem = (bookingSystemId?: string): Action => ({
    type: ActionType.UpdateBookingSystem,
    bookingSystemId,
});

export const updatePromotionCode = (promotionCode?: string): Action => ({
    type: ActionType.UpdatePromotionCode,
    promotionCode,
});

export const updateDivision = (divisionId?: string): Action => ({
    type: ActionType.UpdateDivision,
    divisionId,
});

export const setDivisions = (divisions: ReferenceDataItem[]): Action => ({
    type: ActionType.SetDivisions,
    divisions,
});

export const updateSelectedProductType = (productType: 'Course' | 'Accommodation' | 'Transfer' | 'Add-ons' | 'Package'): Action => ({
    type: ActionType.UpdateSelectedProductType,
    productType,
});

export const addProduct = (product: { id: string; name: string; code?: string; type: 'Course' | 'Accommodation' | 'Transfer' | 'Add-ons' | 'Package'; accommodationType?: 'Residence' | 'Homestay'; accommodationName?: string | null }): Action => ({
    type: ActionType.AddProduct,
    product,
});

export const removeProduct = (productId: string): Action => ({
    type: ActionType.RemoveProduct,
    productId,
});

export const updateProductDateFrom = (productId: string, date?: string): Action => ({
    type: ActionType.UpdateProductDateFrom,
    productId,
    date,
});

export const updateProductDateTo = (productId: string, date?: string): Action => ({
    type: ActionType.UpdateProductDateTo,
    productId,
    date,
});

export const updateProductSearchTerm = (searchTerm: string): Action => ({
    type: ActionType.UpdateProductSearchTerm,
    searchTerm,
});

export const updateExcludeCommissions = (excludeCommissions: boolean): Action => ({
    type: ActionType.UpdateExcludeCommissions,
    excludeCommissions,
});

export const updateEarlyBirds = (earlyBirds: boolean): Action => ({
    type: ActionType.UpdateEarlyBirds,
    earlyBirds,
});

export const updateMarketDiscount = (marketDiscount: boolean): Action => ({
    type: ActionType.UpdateMarketDiscount,
    marketDiscount,
});

export const updatePricingScenario = (
    pricingScenario: 'New booking' | 'Amendment before Arrival' | 'Amendment after Arrival'
): Action => ({
    type: ActionType.UpdatePricingScenario,
    pricingScenario,
});

export const updateAmendmentDate = (amendmentDate?: string): Action => ({
    type: ActionType.UpdateAmendmentDate,
    amendmentDate,
});

export const updatePriceLockToken = (priceLockToken?: string): Action => ({
    type: ActionType.UpdatePriceLockToken,
    priceLockToken,
});

export const setSummary = (summary?: CalculatorSummary): Action => ({
    type: ActionType.SetSummary,
    summary,
});

export const setCalculating = (isCalculating: boolean): Action => ({
    type: ActionType.SetCalculating,
    isCalculating,
});

export const pageLoaded = (
    countries: ReferenceDataItem[],
    currencies: ReferenceDataItem[],
    centres: ReferenceDataItem[],
    schools: ReferenceDataItem[],
    bookingSystems: ReferenceDataItem[],
    agents: ReferenceDataItem[]
): Action => ({
    type: ActionType.PageLoaded,
    countries,
    currencies,
    centres,
    schools,
    bookingSystems,
    agents,
});

export const reloadReferenceData = (
    countries: ReferenceDataItem[],
    currencies: ReferenceDataItem[],
    centres: ReferenceDataItem[],
    schools: ReferenceDataItem[]
): Action => ({
    type: ActionType.ReloadReferenceData,
    countries,
    currencies,
    centres,
    schools,
});

export const setReferenceDataLoading = (isLoading: boolean): Action => ({
    type: ActionType.SetReferenceDataLoading,
    isLoading,
});

export const reloadAgents = (agents: ReferenceDataItem[]): Action => ({
    type: ActionType.ReloadAgents,
    agents,
});

export const updateAgentOffice = (agentOfficeId?: string): Action => ({
    type: ActionType.UpdateAgentOffice,
    agentOfficeId,
});

export const loadAgentOffices = (agentOffices: ReferenceDataItem[]): Action => ({
    type: ActionType.LoadAgentOffices,
    agentOffices,
});